import React, { useState } from "react";
import { func } from "prop-types";
import ReactTooltip from "react-tooltip";

import DeleteWatchListEntryModal from "../../delete-watch-list-entry-modal";
import { watchListEntryType } from "../../../../../prop-types";
import { HiOutlineTrash } from "react-icons/hi";
import useRoles from "../../../../../components/hooks/useRoles";

const WatchListEntryTableRow = ({ watchListEntry, handleDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isCustomerSupport } = useRoles();
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <React.Fragment>
      <tr className="high-risk-country-row">
        <td className="fullname-td">{watchListEntry.countryName}</td>
        <td className="high-risk-countries-table-action-col pt-0 pb-0">
          {
            <React.Fragment>
              <ReactTooltip id="delete-icon" type="error">
                <span>Delete</span>
              </ReactTooltip>
              {isCustomerSupport ? (
                <HiOutlineTrash
                  className="pointer delete-icon"
                  size="1.7em"
                  data-tip
                  data-for="delete-icon"
                  color="lightGray"
                />
              ) : (
                <HiOutlineTrash
                  className="pointer delete-icon"
                  size="1.7em"
                  data-tip
                  data-for="delete-icon"
                  // color="red"
                  onClick={toggle}
                />
              )}
            </React.Fragment>
          }
        </td>
      </tr>
      <DeleteWatchListEntryModal
        toggle={toggle}
        handleDelete={handleDelete}
        id={watchListEntry.id}
        isOpen={isOpen}
      />
    </React.Fragment>
  );
};

WatchListEntryTableRow.propTypes = {
  handleDelete: func.isRequired,
  watchListEntry: watchListEntryType.isRequired,
};

export default WatchListEntryTableRow;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/components/watch-list-entries-table/watch-list-entry-table-row/WatchListEntryTableRow.jsx